
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      required: true,
      default: 0,
    },
    display: {
      type: String,
      required: true,
      default: '0',
    },
  },
  setup() {
    const RADIUS_OF_THE_OFFSET = 25

    return {
      circumference: RADIUS_OF_THE_OFFSET * 2 * Math.PI,
      RADIUS_OF_THE_OFFSET,
    }
  },
})
